import PhoneInput, { Value } from 'react-phone-number-input';
import { useIntl } from 'react-intl';

import 'react-phone-number-input/style.css';
import styles from './PhoneNumberInput.module.scss';

type Props = {
    id?: string;
    value: string;
    onChange: (value: Value) => void;
}

const PhoneNumberInput = ({
    id,
    value,
    onChange,
}: Props) => {
    const intl = useIntl();

    return (
        <PhoneInput
            id={id}
            placeholder={intl.formatMessage(messages.phonePlaceholder)}
            className={styles.container}
            limitMaxLength
            value={value}
            onChange={onChange}
        />
    );
};

const messages = {
    phonePlaceholder: {
        id: 'src.Components.Common.PhoneNumber.PhoneNumberInput.phonePlaceholder',
        defaultMessage: 'Wprowadź numer telefonu',
    },
};

export default PhoneNumberInput;
